import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { WindowConfig, CurtainStyleConfig, FabricConfig, LiningConfig, HardwareConfig, CutCalculation } from '@/types/curtain';

interface ConfigStore {
  currentStep: number;
  windowConfig: Partial<WindowConfig>;
  styleConfig: Partial<CurtainStyleConfig>;
  fabricConfig: Partial<FabricConfig>;
  liningConfig: Partial<LiningConfig>;
  hardwareConfig: Partial<HardwareConfig>;
  calculation: CutCalculation | null;
  
  isVisualizerOpen: boolean;
  
  setStep: (step: number) => void;
  nextStep: () => void;
  prevStep: () => void;
  updateWindowConfig: (config: Partial<WindowConfig>) => void;
  updateStyleConfig: (config: Partial<CurtainStyleConfig>) => void;
  updateFabricConfig: (config: Partial<FabricConfig>) => void;
  updateLiningConfig: (config: Partial<LiningConfig>) => void;
  updateHardwareConfig: (config: Partial<HardwareConfig>) => void;
  setCalculation: (calc: CutCalculation) => void;
  setVisualizerOpen: (isOpen: boolean) => void;
  resetAll: () => void;
}

const initialState = {
  currentStep: 0,
  windowConfig: {},
  styleConfig: {},
  fabricConfig: {},
  liningConfig: {},
  hardwareConfig: {},
  calculation: null,
  isVisualizerOpen: false,
};

export const useConfigStore = create<ConfigStore>()(
  persist(
    (set) => ({
      ...initialState,
      setStep: (step) => set({ currentStep: step }),
      nextStep: () => set((state) => ({ currentStep: Math.min(state.currentStep + 1, 4) })),
      prevStep: () => set((state) => ({ currentStep: Math.max(state.currentStep - 1, 0) })),
      updateWindowConfig: (config) => set((state) => ({ windowConfig: { ...state.windowConfig, ...config } })),
      updateStyleConfig: (config) => set((state) => ({ styleConfig: { ...state.styleConfig, ...config } })),
      updateFabricConfig: (config) => set((state) => ({ fabricConfig: { ...state.fabricConfig, ...config } })),
      updateLiningConfig: (config) => set((state) => ({ liningConfig: { ...state.liningConfig, ...config } })),
      updateHardwareConfig: (config) => set((state) => ({ hardwareConfig: { ...state.hardwareConfig, ...config } })),
      setCalculation: (calc) => set({ calculation: calc }),
      setVisualizerOpen: (isOpen) => set({ isVisualizerOpen: isOpen }),
      resetAll: () => set(initialState),
    }),
    {
      name: 'curtain-config-storage',
    }
  )
);
